import AuthService from '../../services/auth.service';
import axios from 'axios'

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          if (user.access_token) {
            commit('loginSuccess', user);
          }
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    },
    verifyTOTP({commit}, data) {
      return AuthService.verifyTOTP(data)
        .then(response => {
          commit('loginSuccess', response);
          return response
        })
        .catch(error => { throw(error) })
        .finally(() => {
        })

    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess');
          return Promise.resolve(response.data);
        },
        error => {
          commit('registerFailure');
          return Promise.reject(error);
        }
      );
    }
  },
  getters: {
    isAuthenticated(state) {
      return state.status.loggedIn
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.user = user;
      state.status.loggedIn = true;
    },
    loginFailure(state) {
      state.user = null;
      state.status.loggedIn = false;
    },
    logout(state) {
      state.user = null;
      state.status.loggedIn = false;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    }
  }
};